import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  CrudOption,
} from "../../comp/crud";
import { TextCell, TextCellRemark } from "../../comp/cell";
import {
  ApiClient,
  displayLeadAssignStatus,
  displayLeadStatus,
  getLeadAssignStatusOpt,
  getLeadStatusOpt,
  displayLeadType,
  getLeadTypeOpt,
  Lead,
} from "../../api/ApiClient";
import React, { useContext, useEffect, useState, useRef } from "react";
import {
  displayStar,
  formatDuration,
  formatRelativeTime,
  formatAmountZhCn,
} from "../../utils";
import {
  Button,
  Form,
  Modal,
  Toast,
  Tag,
  withField,
  Typography,
} from "@douyinfe/semi-ui";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

import "../clientConfig/index.scss";

import "./modal.css";
import pubsub from "pubsub-js";
import {IconModalStroked} from "@douyinfe/semi-icons";
import { render } from "react-dom";

export interface LeadReportItemProps {
  reportType?: string;
  dataType?: string;
  userId?: number;
  saleIds?: [];
  teamId?: number;
  createdAt?: string;
  city?: string;
  belongTeamId?: number;
  star?: number;
  source?: string;
  leadType?: string;
  createdDate?: string;
  otherCondition?: string;
}

export default function LeadReportItem(props: LeadReportItemProps) {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [hideNowSale, setHideNowSale] = useState(true); 
  const [viewDetailMode, setViewDetailMode] = useState(true); 
  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([] as any[]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const username = localStorage.getItem("username");

  const [filterStar, setFilterStar] = useState(true);
  const [filterCity, setFilterCity] = useState(true);
  const [filterCreatedAt, setFilterCreatedAt] = useState(true);
  const [filterLeadType, setFilterLeadType] = useState(true);
  const [showWasteModal, setShowWasteModal] = useState(false);
  const [wasteFormApi, setWasteFormApi] = useState(
       undefined as undefined | FormApi
     );
  const [wasteSaving, setWasteSaving] = useState(false);

  const [showPoolModal, setShowPoolModal] = useState(false);
  const [poolFormApi, setPoolFormApi] = useState(
      undefined as undefined | FormApi
  );
  const [poolSaving, setPoolSaving] = useState(false);

  let apiClient = ApiClient.getDefault();
  let cols: Col[] = [
    {
      name: "姓名",
      key: "name",
      width: 80,
      colSort: 1,
      showInFilter: true,
      type: ColType.STRING,
      render: (value, record, index) => {
        if (record.status == "PENDING_CONTACT") {
          return (
            <Button
              theme="borderless"
              type="danger"
              onClick={() => detailAction(record, crudApi?.getData())}
            >
              {value}
            </Button>
          );
        } else if (record.againAssign) {
          return (
            <Button
              theme="borderless"
              type="primary"
              onClick={() => detailAction(record, crudApi?.getData())}
            >
              {value}
            </Button>
          );
        } else {
          return (
            <Button
              theme="borderless"
              type="tertiary"
              onClick={() => detailAction(record, crudApi?.getData())}
            >
              {value}
            </Button>
          );
        }
      },
    },
    {
      name: "客户类型",
      key: "leadType",
      width: 90,
      colSort: 1,
      showInFilter: filterLeadType,
      hideInCreate: true,
      render: (value, index) => displayLeadType(value),
      getOptions: () => Promise.resolve(getLeadTypeOpt()),
      type: ColType.SELECT,
    },
    {
      name: "手机",
      key: "mobile",
      showInFilter: true,
      hideInList: true,
      optional: true,
      type: ColType.STRING,
    },
    {
      name: "城市",
      optional: true,
      key: "applyCity",
      width: 50,
      showInFilter: filterCity,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "销售",
      optional: true,
      hideInList: true,
      key: "saleId",
      type: ColType.STRING,
    },
    {
      name: "销售",
      optional: true,
      key: "saleName",
      width: 80,
      type: ColType.STRING,
    },
    {
      name: "当前销售",
      optional: true,
      hideInList: hideNowSale,
      key: "nowSaleName",
      width: 80,
      type: ColType.STRING,
    },
    {
      name: "金额",
      key: "applyAmount",
      width: 80,
      colSort: 4,
      type: ColType.STRING,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "星级",
      key: "star",
      width: 50,
      colSort: 5,
      showInFilter: filterStar,
      hideInCreate: true,
      render: (a) => displayStar(a),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
  
    {
      name: "状态",
      key: "status",
      width: 80,
      colSort: 6,
      showInFilter: true,
      hideInCreate: true,
      render: (value, index) => {
        if (value == "PENDING_CONTACT") {
          return (
            <Tag color="red" key={value} size='large'
            shape='circle'
            type='solid'> {displayLeadStatus(value)} </Tag>
          );
        } else if (value == "UNREACHABLE") {
          return (<Tag color="blue" key={value} size='large'
          shape='circle'
          type='solid'> {displayLeadStatus(value)} </Tag>);
        }
        else if (value == "OUT_LEAD") {
          return (<Tag color="grey" key={value} size='large'
          shape='circle'
          type='solid'> {displayLeadStatus(value)} </Tag>);
        }else if (value == "INVITATION_IN_PROGRESS") {
                  return (
                    <Tag
                      color="orange"
                      key={value}
                      size="large"
                      shape="circle"
                      type="solid"
                    >
                      {" "}
                      {displayLeadStatus(value)}{" "}
                    </Tag>
                  );
                } else if (value == "NON_COMPLIANCE") {
                  return (
                    <Tag
                      color="teal"
                      key={value}
                      size="large"
                      shape="circle"
                      type="solid"
                    >
                      {" "}
                      {displayLeadStatus(value)}{" "}
                    </Tag>
                  );
                }
        else if (value == "PENDING_VISIT") {
          return (<Tag color="purple" key={value} size='large'
          shape='circle'
          type='solid'> {displayLeadStatus(value)} </Tag>);
        }
        else if (value == "VISITED") {
          return (<Tag color="green" key={value} size='large'
          shape='circle'
          type='solid'> {displayLeadStatus(value)} </Tag>);
        }else if (value == "SIGNED_CONTRACT") {
          return (<Tag color="violet" key={value} size='large'
          shape='circle'
          type='solid'> {displayLeadStatus(value)} </Tag>);
        }
        else if (value == "PAID") {
          return (<Tag color="yellow" key={value} size='large'
          shape='circle'
          type='solid'> {displayLeadStatus(value)} </Tag>);
        }
        else {
          return (<Tag  key={value} size='large'
          shape='circle'
          type='solid'> {displayLeadStatus(value)} </Tag>);
        }
      },
      getOptions: () => Promise.resolve(getLeadStatusOpt()),
      type: ColType.SELECT,
    },
    {
      name: "跟进记录",
      key: "contactLogs",
      colSort: 8,
      hideInEdit: true,
      width: 210,
      hideInCreate: true,
      render: (value, index) => (
        <TextCellRemark moreText={value ? value : []} width={200} />
      ),
      type: ColType.STRING,
    },
    {
      name: "资质",
      key: "remark",
      colSort: 7,
      type: ColType.STRING,
      width: 210,
      hideInCreate: true,
      showInFilter: true,
      render: (a, b, c) => <TextCell text={b.remark} width={200} />,
    },
    {
      name: "入库时间",
      key: "createdAt",
      colSort: 11,
      hideInCreate: true,
      showInFilter: filterCreatedAt,
      width: 150,
      type: ColType.DATE_RANGE,
      defaultSortOrder: "descend",
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
    {
      name: "上次联系时间",
      key: "lastContactAt",
      width: 150,
      colSort: 9,
      hideInCreate: true,
      showInFilter: false,
      defaultSortOrder: false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
    {
      name: "分配时间",
      key: "assignedAt",
      width: 150,
      colSort: 10,
      defaultSortOrder: false,
      hideInCreate: true,
      showInFilter: false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
    {
      name: "上门时间",
      key: "actVisitTimeNew",
      width: 150,
      colSort: 10,
      defaultSortOrder: false,
      hideInCreate: true,
      showInFilter: false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
  ];

  const nowSaleCol = [
    {
      name: "销售",
      optional: true,
      hideInList: true,
      key: "nowSaleId",
      type: ColType.STRING,
    },
    {
      name: "销售",
      optional: true,
      key: "nowSaleName",
      type: ColType.STRING,
    },
  ];
  const sourceCol = 
    {
      name: "来源",
      optional: true,
      key: "source",
      width: 50,
      type: ColType.STRING,
      render: (v,a) => a.source,
    };

    const sourceDkHitCol = 
    {
      name: "撞库来源",
      optional: true,
      key: "refSource",
      width: 50,
      type: ColType.STRING,
      render: (v,a) => a.refSource ,
    };
  
    if (props.reportType == "StatSource") {
      if(props.otherCondition == "isHitReport=2"){
        cols.unshift(sourceDkHitCol);
      }else{
        cols.unshift(sourceCol);

      }
    }

  useEffect(() => {
    
    if (props.reportType == "StatAssignVisit" && props.dataType == "assign") {
      setHideNowSale(false);
    }
    if (props.star != undefined && props.star>=0) {
      setFilterStar(false);
    }
    if (props.city&&props.city!="") {
      setFilterCity(false);
    }
    if (props.createdAt&&props.createdAt!="") {
      setFilterCreatedAt(false);
    }if (props.leadType&&props.leadType!="") {
      setFilterLeadType(false);
    }
    const role = localStorage.getItem("role");
    if(role == "source") {
      setViewDetailMode(true);
    }else{
      setViewDetailMode(false);
    }
      

    let currUsername;
    if(role == "op_manager" || role == "monitor"){
      currUsername = "root";
    }else{
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));

  }, []);

  const actions: CrudAction[] = [];

  const handleAssignButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setSelectedLeads(rows);
    setShowAssignModal(true);
    let strIds = localStorage.getItem("assignToIds");
    if (strIds) {
      setSelectedMembers(JSON.parse(strIds));
    }
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      //保存上次分配用户
      let assignToIds = assignFormApi!.getValue("assignToIds");
      localStorage.setItem("assignToIds", JSON.stringify(assignToIds));

      setSelectedLeads([]);
      crudApi?.refresh();
      //我的客户需要刷新
      localStorage.setItem("my-refresh", "true");
      localStorage.setItem("new-refresh", "true");
      localStorage.setItem("all-refresh", "true");
      setAssignSaving(false);
      setShowAssignModal(false);

      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setAssignSaving(false);
    }
  };

    const handlePoolClick = async () => {
    setPoolSaving(true);
    try {
      await poolFormApi!.validate();
      await apiClient.request(
        "/leads/pool",
        "POST",
        undefined,
        poolFormApi!.getValues()
      );

      crudApi?.refresh();
      //公共池需要刷新
      localStorage.setItem("pool-refresh", "true");
      setPoolSaving(false);
      setShowPoolModal(false);
      setSelectedLeads([]);
      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      console.log(e);
      setPoolSaving(false);
    }
  };

  const handleWasteClick = async () => {
    setWasteSaving(true);
    try {
      await wasteFormApi!.validate();
      await apiClient.request(
        "/leads/waste",
        "POST",
        undefined,
        wasteFormApi!.getValues()
      );

      crudApi?.refresh();
      //废物池需要刷新
      localStorage.setItem("waste-refresh", "true");
      setWasteSaving(false);
      setShowWasteModal(false);
      setSelectedLeads([]);
      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      console.log(e);
      setWasteSaving(false);
    }
  };

  const handlePoolButtonClick = (a: any, rows: any) => {
      if (!rows || rows.length == 0) {
        Toast.info("请选择客户");
        return;
      }
      setSelectedLeads(rows);
      setShowPoolModal(true);
    };
  
  const handleWasteButtonClick = (a: any, rows: any) => {
      if (!rows || rows.length == 0) {
        Toast.info("请选择客户");
        return;
      }
      setSelectedLeads(rows);
      setShowWasteModal(true);
    };

  const assignAction: CrudAction = {
    name: "分配客户",
    action: handleAssignButtonClick,
  };
  const sendToPoolAction: CrudAction = {
      name: "送回公共池",
      action: handlePoolButtonClick,
    };
  
    const sendToWasteAction: CrudAction = {
      name: "送回废物池",
      action: handleWasteButtonClick,
    };
  actions.push(assignAction);
 actions.push(sendToPoolAction);
 actions.push(sendToWasteAction);

  const initParams = {
    createdAt: props.createdAt,
    city: props.city,
    belongTeamId: props.belongTeamId,
    star: props.star,
    leadType: props.leadType,
    source: props.source,
    userId: props.userId,
    saleIds: props.saleIds,
    teamId: props.teamId,
    reportType: props.reportType,
    dataType: props.dataType,
    createdDate: props.createdDate,
    otherCondition: props.otherCondition,
  };

  //打开详情
  const detailAction = (a: Lead, all: Lead[] | undefined) => {
    const w = window.open("about:blank");
    let queryParams = {
      ...crudApi?.getQueryParams(),
      type:'all'
    }
    if (w != null) {
      //获取表格data的id列表
      const ids = crudApi?.getData()?.map((i) => i.nowLeadId);
      const data = {
        id: a.nowLeadId,
        ids: ids,
        viewMode: viewDetailMode,
        visitMode: false,
        leadFrom: 'report',
        queryParams: queryParams,
      };
      w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const renderLabel = (label:any, item:any) => (
      <div style={{
        padding: '6px 8px',
        lineHeight: 1.0
      }}>
        <div style={{
          fontWeight: 500,
          color: 'var(--semi-color-text-0)',
          fontSize: 14
        }}>
          {label}
          <span style={{
            fontSize: 12,
            color: 'var(--semi-color-text-2)',
            marginLeft: 10
          }}>
                {item.labelSubText}
            </span>
        </div>
      </div>
  );

  return (
      <div style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          flex: 1,
          overflow: 'auto', // 关键：启用滚动
        }}>
       <Modal icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        style={{ width: 1200, height: 650 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.TreeSelect
              placeholder="请选择分配给谁"
              rules={[{ required: true, message: "请填写" }]}
              style={{ width: "100%" }}
              field="assignToIds"
              label="销售"
              //defaultExpandAll
              checkRelation="unRelated"
              leafOnly
              multiple
              treeData={teamMembersTree}
              initValue={selectedMembers}
              filterTreeNode
              showFilteredOnly={true}
              searchPlaceholder="请输入关键字开始搜索"
              renderLabel={renderLabel}
              autoAdjustOverflow={false}
              virtualize={{
                itemSize: 28,
                height: 400
              }}
          ></Form.TreeSelect>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.nowLeadId)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.nowLeadId + ""} value={l.nowLeadId}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>


        </Form>
      </Modal>
         <Modal
              icon={
                <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
              }
              title="送回公共池"
              visible={showPoolModal}
              okText="送回公共池"
              confirmLoading={poolSaving}
              onOk={handlePoolClick}
              onCancel={() => setShowPoolModal(false)}
            >
              <Form getFormApi={(formApi) => setPoolFormApi(formApi)}>
                <Form.Select
                  rules={[{ required: true, message: "请填写" }]}
                  disabled
                  initValue={selectedLeads.map((l) => l.id)}
                  style={{ width: "100%" }}
                  multiple
                  field="leadIds"
                  label="客户"
                >
                  {selectedLeads.map((l) => (
                    <Form.Select.Option key={l.id + ""} value={l.id}>
                      {l.name}
                    </Form.Select.Option>
                  ))}
                </Form.Select>
              </Form>
            </Modal>
       <Modal
              icon={
                <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
              }
              title="送回废物池"
              visible={showWasteModal}
              okText="送回废物池"
              confirmLoading={wasteSaving}
              onOk={handleWasteClick}
              onCancel={() => setShowWasteModal(false)}
            >
              <Form getFormApi={(formApi) => setWasteFormApi(formApi)}>
                <Form.Select
                  rules={[{ required: true, message: "请填写" }]}
                  disabled
                  initValue={selectedLeads.map((l) => l.id)}
                  style={{ width: "100%" }}
                  multiple
                  field="leadIds"
                  label="客户"
                >
                  {selectedLeads.map((l) => (
                    <Form.Select.Option key={l.id + ""} value={l.id}>
                      {l.name}
                    </Form.Select.Option>
                  ))}
                </Form.Select>
              </Form>
            </Modal>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        params={initParams}
        actions={actions}
        select={true}
        canUpdate={false}
        canCreate={false}
        name="客户列表"
        entityKey="leadReportItem"
        pageSize={50}
        rowActionWidth={60}
        cols={cols}
      />
    </div>
      </div>
  );
}
